export enum ColumnType {
  text,
  select,
  date,
  icon,
  file,
  numeric,
  dateTime
}
